/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PossibleAnswerDto } from './PossibleAnswerDto';
import {
    PossibleAnswerDtoFromJSON,
    PossibleAnswerDtoFromJSONTyped,
    PossibleAnswerDtoToJSON,
    PossibleAnswerDtoToJSONTyped,
} from './PossibleAnswerDto';

/**
 * 
 * @export
 * @interface PossibleAnswersResponse
 */
export interface PossibleAnswersResponse {
    /**
     * Question ID
     * @type {string}
     * @memberof PossibleAnswersResponse
     */
    questionId?: string;
    /**
     * Question label
     * @type {string}
     * @memberof PossibleAnswersResponse
     */
    questionLabel?: string;
    /**
     * List of possible answers
     * @type {Array<PossibleAnswerDto>}
     * @memberof PossibleAnswersResponse
     */
    possibleAnswers?: Array<PossibleAnswerDto>;
    /**
     * Total number of possible answers
     * @type {number}
     * @memberof PossibleAnswersResponse
     */
    totalCount?: number;
}

/**
 * Check if a given object implements the PossibleAnswersResponse interface.
 */
export function instanceOfPossibleAnswersResponse(value: object): value is PossibleAnswersResponse {
    return true;
}

export function PossibleAnswersResponseFromJSON(json: any): PossibleAnswersResponse {
    return PossibleAnswersResponseFromJSONTyped(json, false);
}

export function PossibleAnswersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PossibleAnswersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'questionId': json['questionId'] == null ? undefined : json['questionId'],
        'questionLabel': json['questionLabel'] == null ? undefined : json['questionLabel'],
        'possibleAnswers': json['possibleAnswers'] == null ? undefined : ((json['possibleAnswers'] as Array<any>).map(PossibleAnswerDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
    };
}

export function PossibleAnswersResponseToJSON(json: any): PossibleAnswersResponse {
    return PossibleAnswersResponseToJSONTyped(json, false);
}

export function PossibleAnswersResponseToJSONTyped(value?: PossibleAnswersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questionId': value['questionId'],
        'questionLabel': value['questionLabel'],
        'possibleAnswers': value['possibleAnswers'] == null ? undefined : ((value['possibleAnswers'] as Array<any>).map(PossibleAnswerDtoToJSON)),
        'totalCount': value['totalCount'],
    };
}

